import { Link } from 'react-router-dom'
import { Bell, CreditCard, Heart, type LucideIcon } from 'lucide-react'

interface QuickAction {
  name: string
  href: string
  icon: LucideIcon
}

const actions: QuickAction[] = [
  { name: 'Health', href: '/health', icon: Heart },
  { name: 'Alerts', href: '/alerts', icon: Bell },
  { name: 'Money', href: '/financial', icon: CreditCard },
]

/**
 * Row of three tappable mini cards at the bottom of the caregiver home:
 * Health, Alerts, and Money shortcuts.
 */
export function QuickActions() {
  return (
    <div className="grid grid-cols-3 gap-3">
      {actions.map((action) => (
        <Link
          key={action.name}
          to={action.href}
          className="hearth-card hearth-press flex flex-col items-center justify-center gap-2 p-4"
        >
          <action.icon className="h-5 w-5 text-primary-600" />
          <span className="text-[13px] font-medium text-gray-500">{action.name}</span>
        </Link>
      ))}
    </div>
  )
}
